import { createApp } from 'vue';
import { createPinia } from 'pinia'; // 导入createPinia
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'; // 导入持久化插件
import App from './App.vue';
import router from './router'; // 新增路由导入
import 'element-plus/dist/index.css'; //引入element plus样式
import * as ElementPlusIconsVue from '@element-plus/icons-vue'; //引入element plus图标
import './assets/styles/global.scss';

import { ElButton } from 'element-plus';

const app = createApp(App);
const pinia = createPinia(); // 创建Pinia实例
pinia.use(piniaPluginPersistedstate); // 使用持久化插件

//app.config.globalProperties.$ELEMENT = { size: 'small' } //全局设置element plus组件大小
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    //注册element plus图标
    app.component(key, component); //注册element plus图标
}

app.use(router); // 使用路由
app.use(pinia); // 使用Pinia
app.mount('#app');
